export class LoginDTO {
  lanId: any;
  password: any;
}
